<template>
  <q-popover v-model="popover" persistent :disable="disabled" @show="handleShow" @escape-key="closePopover">
    <slot></slot>
  </q-popover>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        popover: false,
        anchorEl: null
      }
    },

    methods: {
      handleShow (event) {
        setTimeout(() => {
          document.body.addEventListener('mousedown', this.hide, true)
          document.body.addEventListener('touchstart', this.hide, true)
        }, 0)

        this.$emit('show', event)
      },

      hide (event) {
        if (event && event.target && this.$el.contains(event.target)) {
          return
        }

        this.$emit('hide', this.closePopover)
      },

      closePopover () {
        this.cleanUp()
        this.popover = false
      },

      cleanUp () {
        document.body.removeEventListener('mousedown', this.hide, true)
        document.body.removeEventListener('touchstart', this.hide, true)
      }
    }
  }
</script>
